module.exports = __webpack_public_path__ + "static/media/LogoMobile.9aab56ff.svg";